export const DEFAULT_MAX_WIDTH = 1180
